import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import axios from 'axios';

// componentes
import { Card, Col, Row } from 'react-bootstrap';
import Carregador from './../../ComponentesCadastro/Carregador';
import PaginacaoComponente from './../../ComponentesCadastro/Paginacao';
import Parametros from './Parametros';
import Registro from './Registro';

// consulta
export default function Consultar(){

    // estados
    const { LoginReducer } = useSelector(state => state);
    const history = useHistory();
    let [parametros, alterarParametros] = useState({
        pagina: 1,
        registrosPorPagina: 10,
        status: ['A'],
        texto: ''
    });
    let [totalRegistros, atualizarTotalRegistros] = useState(0);
    let [carregando, mostrarCarregando] = useState(true);
    let [consulta, alterarConsulta] = useState([]);

    // faz a consulta
    useEffect(() => {

        // faz a requisição
        consultarRegistros();

    }, [parametros]);

    // consultar registros
    async function consultarRegistros(){
        mostrarCarregando(true);

        try{

            // faz a requisição
            let { data } = await axios.get(`/convenio`, { params: parametros });
            alterarConsulta(data.registros);
            atualizarTotalRegistros(parseInt(data.totalRegistros));
            mostrarCarregando(false);

        }catch({response}){

        }

    }

    return <Row>
        <Col>
            <Card className="painel-consulta border-0 shadow-sm" >
                <Card.Header>
                    <Card.Title as='h4'>Convênios</Card.Title>
                    <Parametros parametros={parametros} alterarParametros={alterarParametros}/>
                </Card.Header>
                <Card.Body>
                    <table className="table table-hover tabela">
                        <thead>
                            <tr>
                                <th>Código</th>
                                <th>Descrição</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {consulta.map((registro, a) => 
                                <Registro 
                                    key={a} 
                                    dados={registro.dados}
                                    parametros={parametros}
                                    onClickTr={() => console.log('clicou TR')}
                                    clicouEditar={() => {
                                        history.push(`/painel/convenios/alterar/${registro.dados.pk_cad_convenio}`);
                                    }}
                                />
                            )}
                        </tbody>
                    </table>
                    <PaginacaoComponente
                        pagina={parametros.pagina}
                        registrosPorPagina={parametros.registrosPorPagina}
                        totalRegistros={totalRegistros}
                        alterouPagina={(pagina) => {
                            alterarParametros({...parametros, pagina: pagina});
                        }}
                    />
                    {carregando && 
                        <Carregador className="rounded-bottom" />
                    }
                </Card.Body>
            </Card>
        </Col>
    </Row>
}
